(function () {
  'use strict';

  angular.module('app').controller('AccountController', AccountController);

  AccountController.$inject = ['$scope', '$state', '$rootScope'];

  function AccountController($scope, $state, $rootScope) {
    let vm = this;

    vm.$onInit = function () {
      vm.isVarSelected = $rootScope.varId;
    };
  }
})();
